+function($) {

    // http://openam.github.io/bootstrap-responsive-tabs/
    // responsive tab init
    fakewaffle.responsiveTabs(['xs', 'sm']);

}(jQuery);
